import { Card, Skeleton, Space } from "antd";
import React from "react";
import { FallbackPageContent } from "~/components/Layout/Fallbacks/FallbackPageContent";
import { StatCardSkeleton } from "~/components/Layout/Fallbacks/StatCardSkeleton";
import "~/components/Layout/Fallbacks/Fallbacks.css";

const OPERATIONS_STAT_CARD_COUNT = 7;
const ANALYTICS_STAT_CARD_COUNT = 3;

/** Home dashboard skeleton (alerts + operations stat cards; analytics load via Suspense). */
export const HomePageContentFallback: React.FC = () => (
  <FallbackPageContent aria-label="Loading home">
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      <Card size="small">
        <Skeleton active paragraph={{ rows: 2 }} />
      </Card>
      <div className="app-fallback-stat-grid">
        {Array.from({ length: OPERATIONS_STAT_CARD_COUNT }, (_, i) => (
          <StatCardSkeleton key={`ops-${i}`} />
        ))}
      </div>
      <div className="app-fallback-stat-grid">
        {Array.from({ length: ANALYTICS_STAT_CARD_COUNT }, (_, i) => (
          <StatCardSkeleton key={`analytics-${i}`} />
        ))}
      </div>
    </Space>
  </FallbackPageContent>
);
